import { render } from "./recommendation.vue?vue&type=template&id=651d4a04&scoped=true"
import script from "./recommendation.vue?vue&type=script&lang=js"
export * from "./recommendation.vue?vue&type=script&lang=js"

import "./recommendation.vue?vue&type=style&index=0&id=651d4a04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651d4a04"]])

export default __exports__